<template>
  <div class="d-flex flex-column ga-3">
    <v-card class="translucent-background">
      <v-card-title>{{ report.name }}</v-card-title>
      <v-card-text class="d-flex flex-column">
        <div v-for="item in computedConstraints" :key="index">
          <strong>{{item.title}}:</strong> {{ item.value }}
        </div>
      </v-card-text>
    </v-card>

    <v-card v-if="report.pending_jobs_count > 0" class="translucent-background">
      <v-card-text class="d-flex align-baseline">
        <div class="text-h4 me-2">{{ report.pending_jobs_count }}</div>
        <div>zu erledigende Jobs</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
  import { computed } from "vue";

  const props = defineProps({
    report: {
      type: Object,
      required: true,
    }
  });

  const computedConstraints = computed(() => {
    const constraints = props.report.constraints;
    if (!constraints) return [];
    let items = [
      { title: "Flächengrösse", value: `${constraints.area.min} - ${constraints.area.max} m²` },
      { title: "Mindestabstand", value: `${constraints.area.gap} m` },
      { title: "Flächen (Systemlimit)", value: constraints.limits.area },
      { title: "Lücken (Systemlimit)", value: constraints.limits.gap },
    ];
    if (props.report.district) {
      items.push({ title: "Bezirk", value: props.report.district.name });
    }
    return items.sort((a, b) => a.title.localeCompare(b.title));
  });
</script>

<style scoped>
  .translucent-background {
    background-color: #ffffffcc;
  }
</style>
